define("SDB.SelectYourVehicle.View", [
  "SCView",
  "sdb_select_your_vehicle.tpl",
  "SDB.SelectYourVehicle.SS2Model",
  "SDB.SelectWheelsOrTires.SS2Model",
  "SDB.GetSOVehicleIDs.SS2Model",
  "LiveOrder.Model",
  "Profile.Model",
  "SDB.PLP.Modifications.SS2Model",
  "jquery",
], function (
  SCViewModule,
  sdb_select_your_vehicle_tpl,
  SDBSelectYourVehicleSS2Model,
  SDBSelectWheelsOrTiresSS2Model,
  SOVehicleIDsModel,
  LiveOrderModel,
  ProfileModel,
  SDBPLPModificationsSS2Model,
  $
) {
  "use strict";

  var SCView = SCViewModule.SCView;

  var SDBSelectYourVehicleView = function SDBSelectYourVehicleView(options) {
    SCView.call(this);
    var self = this;

    var url =
      window.location.protocol +
      "//" +
      window.location.hostname +
      "/api/items?include=facets";
    $.ajax({
      url: url,
      context: document.body,
      method: "GET",
      async: true,
    }).done(function (res) {
      self.filters = res.facets;
      self.filters.forEach(function (element) {
        switch (element.id) {
          case "custitem_sdb_wheel_centerbore_filter":
            self.centerboreTop = element.max;
            break;
          case "custitem_sdb_wheel_offset_min_filter":
            self.offsetMinTop = element.max;
            self.offsetMinBottom = element.min;
            break;
          case "custitem_sdb_wheel_width_filter":
            self.widthTop = element.max;
            break;
          case "custitem_sdb_tire_load_index_filter":
            self.loadIndexTop = element.max;
            break;
          default:
            break;
        }
      });
    });

    this.options = options || {};
    this.template = sdb_select_your_vehicle_tpl;

    this.attributes = {
      id: "SDBSelectYourVehicleViewId",
      class: "sdb-select-your-vehicle-view",
    };
    this.showContinue = this.options.showContinue;
    this.model = this.options.model || new SDBSelectYourVehicleSS2Model();
    this.wheelsTiresModel = SDBSelectWheelsOrTiresSS2Model.getInstance();
    this.requiresVehicleSelection =
      this.options.parentView.options.requiresVehicleSelection;
    this.requiresVehicleSelection =
      this.options.parentView.options.requiresVehicleSelection;
    this.requiresVehicleSelectionPayload =
      this.options.parentView.options.requiresVehicleSelectionPayload;

    this.env = this.options.container.getComponent("Environment");
    this.cart = this.options.container.getComponent("Cart");
    var LiveOrder = LiveOrderModel.getInstance();
    var Profile = ProfileModel.getInstance();
    this.arrVehicleOptions = this.env.getConfig(
      "SDBFindPerfectFit".concat(".", "Vehicle")
    );
    this.selections = [];
    var SOVehicleIDs = SOVehicleIDsModel.getInstance();

    var cookieOptions = self.wheelsTiresModel.getCookieOptions();
    if (cookieOptions && cookieOptions.length > 1) {
      var vehicle = cookieOptions.find(function (cookie) {
        return cookie.indexOf("vehicle=") !== -1;
      });
      if (vehicle) vehicle = vehicle.split("=")[1];
      var selectedSize = cookieOptions.find(function (cookie) {
        return cookie.indexOf("selectedSize=") !== -1;
      });
      if (selectedSize) selectedSize = selectedSize.split("=")[1];
    }
    if (vehicle && selectedSize) {
      self.selectedVehicle = JSON.parse(vehicle);
      self.selectedSize = selectedSize;
      self.showDelete = true;
    }
    if (!this.model.get("finalTrims")) {
      this.model.getNextOption(null, true).then(function (response) {
        self.render();
        if (self.selectedVehicle)
          $("#select-vehicle-option-year")
            .val(self.selectedVehicle.year)
            .trigger("change");
      }); // Set the year option on the model
    }
    this.resetModal = function resetModal(new_header) {
      this.page_header = new_header;

      var Layout = this.options.container.getComponent("Layout");
      Layout.showContent(this, { showInModal: true });
    };
    this.changeOptionHandler = function changeOptionHandler(e) {
      var self = this;
      var $target = this.$(e.target).closest("select");
      var name = $target.prop("name");
      var value = $target[0].selectedIndex !== 0 ? $target.val() : null;
      var currentSelection = name.concat(":", value);

      var optionInSelections = _.findIndex(this.selections, function (option) {
        return option.indexOf(name) !== -1;
      });

      if (optionInSelections !== -1) {
        // Replace the same option on the selections array and remove the next sequential selected options
        var unsetOptions = this.selections.splice(
          optionInSelections,
          this.selections.length,
          currentSelection
        );

        /* Validate if the changed option is one if the YMM options and remove the extra options if it is */
        var fixedOptions = this.model.fixedOptions; // Array of strings: ["year","make","model"]
        var selection = currentSelection.slice(
          0,
          currentSelection.indexOf(":")
        );

        if (fixedOptions.indexOf(selection) !== -1) {
          self.model.set({ extraOptions: [] }, { wait: true });
        }

        /* Update the model and remove the options affected by the last change */
        _.each(unsetOptions.slice(1), function (opt) {
          // Conver the selection: 'model:<model_id>' --> 'Model'
          var modelOption = opt.slice(0, opt.indexOf(":")).toPascalCase();
          self.model.unset(modelOption, { wait: true }); // Remove the option from the model
        });
        var selectionObject = _.reduce(
          self.selections,
          function (acc, item) {
            var trimmed = item.replace(/^\s+|\s+$/g, "");
            var parts = trimmed.split(":");
            var key = parts[0];
            var value = parts.slice(1).join(":");
            if (value !== "null") acc[key] = value;
            return acc;
          },
          {}
        );
        self.model.attributes.extraOptions = _.filter(
          self.model.attributes.extraOptions,
          function (value) {
            return !!selectionObject[value.key];
          },
          {}
        );
        Object.keys(self.model.attributes).forEach(function (key) {
          if (!self.model.attributes[key].Options) return;
          var keyIndex = _.findIndex(
            self.model.attributes[key].Options,
            function (option) {
              return option.selected;
            }
          );
          if (
            keyIndex == -1 &&
            key != name.toPascalCase() &&
            key !== "Configid"
          )
            delete self.model.attributes[key];
        });
      } else {
        if (!value) {
          value = name;
          var noNextOption = true;
        }
        // Add the new selected option to the array of selections
        this.selections = this.selections.concat(currentSelection);
      }

      var selection = name !== "year" ? this.selections : currentSelection;
      var optionInModel = this.model.get(name.toPascalCase());

      /* Remove the previous selection for the selected option */
      var previousSelected = _.findWhere(optionInModel.Options, {
        selected: true,
      });
      if (previousSelected) previousSelected.selected = false;

      var selectedModelOption = _.find(
        optionInModel.Options,
        function (option) {
          return option.Value === value || option.Label === value;
        }
      );

      if (selectedModelOption) selectedModelOption.selected = true;
      else if (_.isArray(selection))
        selection.splice(selection.indexOf(currentSelection), 1);
      else selection = null;

      if (!noNextOption) {
        if (selection)
          this.model.getNextOption({ selection: JSON.stringify(selection) });
        else this.model.getNextOption(null, true);
      }
      this.render();
      if (self.selectedVehicle) {
        var selectElement = $("#" + e.currentTarget.id)[0];
        if (!selectElement) return;
        var nextOption = selectElement.nextSibling;
        if (!nextOption || !nextOption.name) return;
        var nextValue = _.findWhere(nextOption, {
          label: self.selectedVehicle[nextOption.name],
        });
        if (!nextValue)
          nextValue = _.findWhere(nextOption, {
            value: self.selectedVehicle[nextOption.name],
          });
        if (nextValue) nextValue = nextValue.value;
        if (nextOption.name == "Tire Size") nextValue = self.selectedSize;
        $('[name="' + nextOption.name + '"]')
          .val(nextValue)
          .trigger("change");
        if (nextOption.name == "Tire Size" || self.model.get("finalTrims")) {
          delete self.selectedVehicle;
          delete self.selectedSize;
        }
      }
    };
    this.updatedVehicleOptions = function updatedVehicleOptions() {
      var self = this;

      var vehicleOptions = this.arrVehicleOptions;
      var extraOptions = this.model.get("extraOptions");

      if (!_.isEmpty(extraOptions)) {
        vehicleOptions = vehicleOptions.concat(extraOptions);
      }

      return _.map(vehicleOptions, function (vehicleOption) {
        var optionName = vehicleOption.name.toPascalCase();
        var modelOption = self.model.get(optionName);

        if (!modelOption) {
          return {
            name: vehicleOption.name,
            facet: vehicleOption.facet,
          };
        }

        return _.extend(vehicleOption, {
          key: modelOption.Key,
          options: modelOption.Options,
        });
      });
    };

    this.composeSelectedVehicle = function composeSelectedVehicle() {
      var self = this;

      var year = _.findWhere(self.model.attributes.Year.Options, {
        selected: true,
      });
      var make = _.findWhere(self.model.attributes.Make.Options, {
        selected: true,
      });
      var model = _.findWhere(self.model.attributes.Model.Options, {
        selected: true,
      });

      var yearLabel = year.Label;
      var makeLabel = make.Label;
      var modelLabel = model.Label;

      var vehicle = {
        year: yearLabel,
        make: makeLabel,
        model: modelLabel,
      };

      return vehicle;
    };

    this.updateModalContent = function updateModalContent() {
      var self = this;
      if (self.selectedVehicle) return;

      if (!this.options.isMake && !this.options.notRedirect) {
        var vehicleYear = _.filter(
          this.arrVehicleOptions[0].options,
          function (vehicleOption) {
            return vehicleOption.selected;
          }
        ).map(function (vehicleOption) {
          return vehicleOption.Value;
        });

        var vehicleMake = _.filter(
          this.arrVehicleOptions[1].options,
          function (vehicleOption) {
            return vehicleOption.selected;
          }
        ).map(function (vehicleOption) {
          return vehicleOption.Label;
        });

        var vehicleModel = _.filter(
          this.arrVehicleOptions[2].options,
          function (vehicleOption) {
            return vehicleOption.selected;
          }
        ).map(function (vehicleOption) {
          return vehicleOption.Label;
        });

        var vehicle = {
          year: vehicleYear[0],
          make: vehicleMake[0],
          model: vehicleModel[0],
        };
        var cookieOptions = self.wheelsTiresModel.getCookieOptions();
        if (cookieOptions && cookieOptions.length) {
          var selectedSize = cookieOptions.find(function (cookie) {
            return cookie.indexOf("selectedSize=") !== -1;
          });
          if (selectedSize) selectedSize = selectedSize.split("=")[1];
        }
        this.model.attributes.extraOptions.forEach(function (element) {
          if (element.key == "Tire Size") return;
          vehicle[element.key] = _.filter(
            element.options,
            function (vehicleOption) {
              return vehicleOption.selected;
            }
          ).map(function (vehicleOption) {
            return vehicleOption.Value;
          })[0];
        });
        this.wheelsTiresModel.setCookieOptions({
          vehicle: JSON.stringify(vehicle),
          selectedSize: selectedSize,
          vehicleConfig: self.model.getConfigurationId(),
        });
        if (this.options.showContinue) return;
        this.model.set({ chooseWheelsOrTires: true }, { wait: true });
        var newModalHeader = "Select the item type";
        this.resetModal(newModalHeader);
      } else {
        var selectModal = document.querySelector(".global-views-modal-content");
        selectModal.style.display = "none";

        this.wheelsTiresModel
          .fetch({
            async: true,
            cache: true,
            data: {
              configurationId: this.model.getConfigurationId(),
            },
          })
          .done(function (response) {
            var data = response.data;
            var vehicle = self.composeSelectedVehicle();

            var cookieOptions = self.wheelsTiresModel.getCookieOptions();
            if (cookieOptions && cookieOptions.length) {
              var selectedSize = cookieOptions.find(function (cookie) {
                return cookie.indexOf("selectedSize=") !== -1;
              });
              if (selectedSize) selectedSize = selectedSize.split("=")[1];
            }

            self.wheelsTiresModel.setCookieOptions({
              isSelectedTires: false,
              vehicleConfig: self.model.getConfigurationId(),
              frontSizeDescription: data.frontSizeDescription,
              vehicle: JSON.stringify(vehicle),
              selectedSize: selectedSize,
            });

            if (!self.options.notRedirect) {
              self.redirectToSearch();
            } else {
              self.options.container.getLayout().closeModal(this);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    };

    this.selectWorTHandler = function selectWorTHandler(e) {
      var self = this;
      var $target = this.$(e.target);
      var id = $target.get(0).id;
      var isSelectedTires = id === "tires";

      this.wheelsTiresModel
        .fetch({
          async: true,
          cache: true,
          data: {
            configurationId: this.model.getConfigurationId(),
          },
        })
        .done(function (response) {
          var data = response.data;

          var year = _.findWhere(self.model.attributes.Year.Options, {
            selected: true,
          });
          var make = _.findWhere(self.model.attributes.Make.Options, {
            selected: true,
          });
          var model = _.findWhere(self.model.attributes.Model.Options, {
            selected: true,
          });
          var cookieOptions = self.wheelsTiresModel.getCookieOptions();
          if (cookieOptions && cookieOptions.length) {
            var selectedSize = cookieOptions.find(function (cookie) {
              return cookie.indexOf("selectedSize=") !== -1;
            });
            if (selectedSize) selectedSize = selectedSize.split("=")[1];
          }

          var yearLabel = year.Label;
          var makeLabel = make.Label;
          var modelLabel = model.Label;

          var vehicle = {
            year: yearLabel,
            make: makeLabel,
            model: modelLabel,
          };

          var valuesWithKey = _.reduce(
            Object.keys(self.model.attributes),
            function (result, key) {
              var attr = self.model.attributes[key];
              if (attr.Key) {
                result[attr.Key] = attr;
              }
              return result;
            },
            {}
          );

          var selectionObject = _.reduce(
            self.selections,
            function (acc, item) {
              var trimmed = item.replace(/^\s+|\s+$/g, "");
              var parts = trimmed.split(":");
              var key = parts[0];
              var value = parts.slice(1).join(":");
              acc[key] = value;
              return acc;
            },
            {}
          );

          self.model.attributes.extraOptions.forEach(function (element) {
            if (element.key == "Tire Size" || !selectionObject[element.key])
              return;
            var valueKey = _.findWhere(valuesWithKey[element.key].Options, {
              Value: selectionObject[element.key],
            });
            if (!valueKey) return;
            vehicle[element.key] = valueKey.Value;
          });

          self.wheelsTiresModel.setCookieOptions({
            isSelectedTires: isSelectedTires,
            vehicleConfig: self.model.getConfigurationId(),
            frontSizeDescription: data.frontSizeDescription,
            vehicle: JSON.stringify(vehicle),
            selectedSize: selectedSize,
          });

          self.redirectToSearch();
        })
        .catch(console.error);
    };

    this.redirectToSearch = function redirectToSearch() {
      // document.cookie = 'setFilters=' + true + '; path=/;';
      self.updatePLPModifications();
      if (self.options.container.getLayout())
        self.options.container.getLayout().closeModal(this);
    };

    this.updatePLPModifications = function updatePLPModifications() {
      var cookies = document.cookie.split(";");
      if (cookies && cookies.length > 1) {
        var vehicleConfig = cookies.find(function (cookie) {
          return cookie.indexOf("vehicleConfig=") !== -1;
        });
        if (vehicleConfig) vehicleConfig = vehicleConfig.split("=")[1];
        var isTire = cookies.find(function (cookie) {
          return cookie.indexOf("isSelectedTires=") !== -1;
        });
        if (isTire) isTire = isTire.split("=")[1];
        var selectedSize = cookies.find(function (cookie) {
          return cookie.indexOf("selectedSize=") !== -1;
        });
        if (selectedSize) selectedSize = selectedSize.split("=")[1];
      }
      if (!vehicleConfig || !selectedSize) return;

      if (!self.modelPLP)
        self.modelPLP = SDBPLPModificationsSS2Model.getInstance();

      self.modelPLP
        .fetch({
          async: false,
          data: {
            vehicleId: vehicleConfig,
            selectedSize: selectedSize,
          },
        })
        .then(function (result) {
          if (!result || result.indexOf("<title>Notice</title>") != -1) {
            console.log("Error:", "Vehicle Record Not Found");
            return;
          }
          var data = JSON.parse(result);
          var filter = data.wheels;
          if (isTire == "true") {
            filter = data.tires;
            if (
              filter["custitem_sdb_tire_load_index_filter"] &&
              self.loadIndexTop != null
            )
              filter["custitem_sdb_tire_load_index_filter"] = {
                from: filter["custitem_sdb_tire_load_index_filter"],
                to: self.loadIndexTop,
              };
          } else {
            if (
              filter["custitem_sdb_wheel_centerbore_filter"] &&
              self.centerboreTop != null
            )
              filter["custitem_sdb_wheel_centerbore_filter"] = {
                from: filter["custitem_sdb_wheel_centerbore_filter"],
                to: self.centerboreTop,
              };
            if (
              filter["custitem_sdb_wheel_offset_max_filter"] &&
              self.offsetMinBottom != null &&
              filter["custitem_sdb_wheel_offset_min_filter"] &&
              self.offsetMinTop != null
            ) {
              filter["custitem_sdb_wheel_offset_min_filter"] = {
                from: filter["custitem_sdb_wheel_offset_min_filter"],
                to: filter["custitem_sdb_wheel_offset_max_filter"],
              };
              delete filter["custitem_sdb_wheel_offset_max_filter"];
            }
            if (
              filter["custitem_sdb_wheel_width_filter"] &&
              self.widthTop != null
            )
              filter["custitem_sdb_wheel_width_filter"] = {
                from: filter["custitem_sdb_wheel_width_filter"],
                to: self.widthTop,
              };
          }
          var finalFilter = {};
          _.each(filter, function (element, key) {
            var facetFound = _.find(self.filters, function (facet) {
              return facet.id === key;
            });
            if (!facetFound) return;
            finalFilter[facetFound.url] = element;
          });
          var searchURL =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/search?";
          var facetDelimiters = SC.CONFIGURATION.facetDelimiters;
          var facetDelimiter = facetDelimiters.betweenDifferentOptions;
          var rangeDelimiter = facetDelimiters.betweenRangeFacetsValues;
          var valuesDelimiter = facetDelimiters.betweenDifferentFacetsValues;
          var equalityDelimiter = facetDelimiters.betweenOptionNameAndValue;
          _.each(finalFilter, function (filter, key) {
            var filterValue;
            if (_.isArray(filter)) filterValue = filter.join(valuesDelimiter);
            else filterValue = filter.from + rangeDelimiter + filter.to;
            if (!filterValue) return;
            searchURL += key + equalityDelimiter + filterValue + facetDelimiter;
          });
          if (searchURL[searchURL.length - 1] === facetDelimiter)
            searchURL = searchURL.substring(0, searchURL.length - 1);
          Backbone.history.location.assign(searchURL, { trigger: true });
        })
        .catch(function (error) {
          console.error(error);
        });
    };

    this.deleteSelectionHandler = function deleteSelectionHandler(e) {
      e.preventDefault();
      self.wheelsTiresModel.removeCookieOptions();
      self.wheelsTiresModel.unset("vehicle");
      self.wheelsTiresModel.unset("vehicleConfig");
      self.model.set({ finalTrims: false }, { silent: true });
      self.model.set({ allOptionsSelected: false }, { silent: true });
      delete self.selectedVehicle;
      var cookies = document.cookie.split(";");
      if (cookies && cookies.length > 1) {
        var selectedSize = cookies.find(function (cookie) {
          return cookie.indexOf("selectedSize=") !== -1;
        });
      }
      if (selectedSize) {
        var cookie = selectedSize.split("=")[0].trim();
        document.cookie =
          cookie + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;";
      }
      self.options.container.getLayout()
        ? self.options.container.getLayout().closeModal(this)
        : null;
      var plp = options.container.getComponent("PLP");
      if (window.location.href.indexOf("search?") !== -1) {
        if (plp) plp.setFilters();
        else {
          var searchURL =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/search?";
          Backbone.history.location.assign(searchURL);
        }
      }
    };

    this.vehicleSearchHandler = function vehicleSearchHandler(e) {
      e.preventDefault();
      self.model.set({ finalTrims: false }, { silent: true });
      self.model.set("finalTrims", true);
    };

    this.getSelectedOptions = function getSelectedOptions(type) {
      var selection = $("#select-vehicle-option-" + type).val();
      return selection;
    };

    this.showSuggestionsHandler = function showSuggestionsHandler(e) {
      e.preventDefault();
      self.options.container.getLayout().closeModal(this);
      self.model.unset("finalTrims");
      self.model.set("finalTrims", true);
      var internalid = self.options.parentView.options.itemID;
      var quantity = self.options.parentView.options.itemQuantity;
      self.cart
        .addLines({
          lines: [
            {
              item: {
                internalid: internalid,
              },
              quantity: quantity,
            },
          ],
        })
        .then(function () {
          var confirmationView = new CartConfirmationView({
            application: self.options.container,
            model: LiveOrder.getLatestAddition(),
          });
          confirmationView.showInModal();
        });
    };

    var CartConfirmationView = require("Cart.Confirmation.View");
    this.skipSelectionHandler = function skipSelectionHandler(e) {
      e.preventDefault();
      var internalid = self.options.parentView.options.itemID;
      var quantity = self.options.parentView.options.itemQuantity;
      self.cart
        .addLines({
          lines: [
            {
              item: {
                internalid: internalid,
              },
              quantity: quantity,
            },
          ],
        })
        .then(function () {
          var confirmationView = new CartConfirmationView({
            application: self.options.container,
            model: LiveOrder.getLatestAddition(),
          });
          confirmationView.showInModal();
        });
      self.options.container.getLayout().closeModal(this);
    };

    this.cartVehicleSelectionHandler = function cartVehicleSelectionHandler(e) {
      e.preventDefault();
      self.options.container.getLayout().closeModal(this);
      self.model.unset("finalTrims");
      self.model.set("finalTrims", true);

      var requiresVehicleSelection =
        self.options.parentView.options.requiresVehicleSelection;
      var requiresVehicleSelectionPayload =
        self.options.parentView.options.requiresVehicleSelectionPayload;

      // Checkout
      if (requiresVehicleSelection && !requiresVehicleSelectionPayload) {
        var touchpoints = self.env.getSiteSetting("touchpoints");
        if (touchpoints && touchpoints.checkout) {
          Backbone.history.location.assign(touchpoints.checkout, {
            trigger: true,
          });
        }
        return;
      }

      // Quote
      if (requiresVehicleSelection && requiresVehicleSelectionPayload) {
        self.options.container.getLayout().closeModal(this);
        if (
          requiresVehicleSelectionPayload.that &&
          requiresVehicleSelectionPayload.callback &&
          requiresVehicleSelectionPayload.arguments
        ) {
          requiresVehicleSelectionPayload.callback.apply(
            requiresVehicleSelectionPayload.that,
            _.toArray(requiresVehicleSelectionPayload.arguments).slice(1)
          );
          return;
        }
      }
      return;
    };

    this.cartVehicleSelectionSkipHandler =
      function cartVehicleSelectionSkipHandler(e) {
        e.preventDefault();

        var requiresVehicleSelection =
          self.options.parentView.options.requiresVehicleSelection;
        var requiresVehicleSelectionPayload =
          self.options.parentView.options.requiresVehicleSelectionPayload;

        // Checkout
        if (requiresVehicleSelection && !requiresVehicleSelectionPayload) {
          var touchpoints = self.env.getSiteSetting("touchpoints");
          if (touchpoints && touchpoints.checkout) {
            Backbone.history.location.assign(touchpoints.checkout, {
              trigger: true,
            });
          }
          return;
        }

        // Quote
        if (requiresVehicleSelection && requiresVehicleSelectionPayload) {
          self.options.container.getLayout().closeModal(this);
          if (
            requiresVehicleSelectionPayload.that &&
            requiresVehicleSelectionPayload.callback &&
            requiresVehicleSelectionPayload.arguments
          ) {
            requiresVehicleSelectionPayload.callback.apply(
              requiresVehicleSelectionPayload.that,
              _.toArray(requiresVehicleSelectionPayload.arguments).slice(1)
            );
            return;
          }
        }
        return;
      };

    this.events = {
      'change [data-type="select-option"]': "changeOptionHandler",
      'click [data-type="delete-selection"]': "deleteSelectionHandler",
      'click [data-type="vehicle-search"]': "vehicleSearchHandler",
      'click [data-type="select-wheels-or-tires"]': "selectWorTHandler",
      'click [data-type="show-suggestions"]': "showSuggestionsHandler",
      'click [data-type="skip-selection"]': "skipSelectionHandler",
      'click [data-type="cart-select-your-vehicle"]':
        "cartVehicleSelectionHandler",
      'click [data-type="cart-select-your-vehicle-skip"]':
        "cartVehicleSelectionSkipHandler",
    };

    this.model.on("change:finalTrims", this.updateModalContent, this);

    this.getContext = function getContext() {
      var arrVehicleOptions = this.updatedVehicleOptions();
      if (this.model.get("allOptionsSelected")) delete this.selectedVehicle;

      return {
        showVehicleOptions:
          !!this.selectedVehicle || !this.model.get("finalTrims"),
        vehicleOptions: arrVehicleOptions,
        chooseWheelsOrTires: !!this.model.get("chooseWheelsOrTires"),
        wheelsOrTiresOptions: [],
        loadingData: !!(
          this.selectedVehicle && !this.model.get("allOptionsSelected")
        ),
        allOptionsSelected: this.model.get("allOptionsSelected"),
        showDelete: this.showDelete && !this.selectedVehicle,
        showContinue: this.showContinue,
        requiresVehicleSelection: this.requiresVehicleSelection,
      };
    };
  };

  SDBSelectYourVehicleView.prototype = Object.create(SCView.prototype);
  SDBSelectYourVehicleView.prototype.costructor = SDBSelectYourVehicleView;

  return SDBSelectYourVehicleView;
});
